import { render, staticRenderFns } from "./cancelOrderDetail.page.vue?vue&type=template&id=8d7e5a4e&"
import script from "./cancelOrderDetail.page.vue?vue&type=script&lang=js&"
export * from "./cancelOrderDetail.page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\mzkj\\要炼\\yl-pc-business\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8d7e5a4e')) {
      api.createRecord('8d7e5a4e', component.options)
    } else {
      api.reload('8d7e5a4e', component.options)
    }
    module.hot.accept("./cancelOrderDetail.page.vue?vue&type=template&id=8d7e5a4e&", function () {
      api.rerender('8d7e5a4e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/afterSale/cancelOrder/cancelOrderDetail.page.vue"
export default component.exports